import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  UrlTree,
} from '@angular/router';
import {
  ExternalApiService,
  ProfileService,
  OUTLAW_QUERY_PARAMS,
  AuthService,
} from '@outlaw/core';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { isGuestToken } from '@app/core/util';

// todo: refactor to service
export const isAuthenticated: CanActivateFn = (
  route: ActivatedRouteSnapshot,
): boolean | UrlTree | Observable<boolean | UrlTree> => {
  const profileService = inject(ProfileService);
  const authService = inject(AuthService);
  const externalApiService = inject(ExternalApiService);
  const router = inject(Router);

  let userToken = profileService.getUserToken();

  const user = profileService.getUser();
  if (user) {
    return true;
  }

  const queryToken = route.queryParams[OUTLAW_QUERY_PARAMS.token];

  if (!userToken && queryToken) {
    userToken = queryToken;
    profileService.updateUserToken(queryToken, { saveToLocalStorage: true });
  }

  if (!userToken || isGuestToken(userToken)) {
    return router.createUrlTree(['/']);
  }

  return authService.getUserData().pipe(
    tap((userData) => profileService.updateUserData(userData)),
    switchMap(() => externalApiService.synchronizeExternalServices()),
    map(() => true),
    catchError(() => of(router.createUrlTree(['/']))),
  );
};
